import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';
import { GridOptions } from 'ag-grid';
import { AutoRoutingService } from '../../../../services/auto-routing.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-auto-routing-by-driver',
  templateUrl: './auto-routing-by-driver.component.html',
  styleUrls: ['./auto-routing-by-driver.component.scss']
})
export class AutoRoutingByDriverComponent implements OnInit, AfterViewInit {

  @Input() scheduleid?: number;
  @Input() jobId?: number;
  @Output() onLoadSchedule?: EventEmitter <any> = new EventEmitter <any>();
  @Output() onClearScheduleId?: EventEmitter <number> = new EventEmitter <number>();
  @Output() onReloadLoadDriver?: EventEmitter <any> = new EventEmitter <any>();
  @Output() activeBtn?: EventEmitter <number> = new EventEmitter <number>();

  gridTrips: GridOptions;
  dataGrid = [];

  constructor(
    private _autoRoutingService: AutoRoutingService,
    private loading: T2LoadingService,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.gridTrips = <GridOptions>{};
    this.gridTrips.columnDefs = this.createDef();
    this.gridTrips.getRowClass = (params) => {
      return this.validateStatusColor(params);
    };
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
     this.getTripsForVehicle();
  }

  onGridReady() {

  }

  recalculateProcess(id) {
    this.loading.show();
     this._autoRoutingService.recalculateSchedule(this.jobId, id)
       .finally(() => {
         this.loading.hiden();
         this.onReloadLoadDriver.emit(true);
       })
       .subscribe(
      data => {
        this.getTripsForVehicle();
      }
    );
  }

  getTripsForVehicle() {
    if (this.jobId !== undefined && this.scheduleid !== undefined) {
      this._autoRoutingService.getTripsForVehicle(this.jobId, this.scheduleid).subscribe(
        data => {
          this.gridTrips.api.setRowData(data);
          this.onClearScheduleId.emit(this.scheduleid);
          this.onLoadSchedule.emit(data);
          this.dataGrid = data;
        }
      );
    }
  }

  createDef() {
    return  [
      { headerName: 'SEQ', field: 'order', width: 70, rowDrag: (params) => {
        return params.node.id !== '0'; }
      },
      { headerName: 'Provider', field: 'providerspeedcode', colId: 'providerspeedcode', width: 70 },
      { headerName: 'Loc. Type', field: 'locationtype', colId: 'locationtype', width: 50 },
      { headerName: 'Remove', colId: 'remove', cellRenderer: (params) => {
          return params.rowIndex === 0 ? '' : '<i class="icofont-ui-close"></i>';
        }, width: 60, cellStyle: { 'text-align': 'center' }},
      { headerName: 'Consecutive', field: 'consecutive', colId: 'consecutive', width: 70 },
      { headerName: 'Service Type', field: 'servicetype', colId: 'servicetype', width: 80 },
      { headerName: 'Companions', field: 'companions', colId: 'companions', width: 40 },
      { headerName: 'Address', field: 'streetadress', colId: 'streetadress', width: 120 },
      { headerName: 'City', field: 'city', colId: 'city', width: 120 },
      { headerName: 'County', field: 'county', colId: 'county', width: 120 },
      { headerName: 'ZipCode', field: 'zipcode', colId: 'zipcode', width: 120 },
      { headerName: 'Rider', field: 'ridername', colId: 'ridername', width: 150 },
      { headerName: 'Appt - DO', field: 'appt', colId: 'appt', width: 120 },
      { headerName: 'PU', field: 'pu', colId: 'pu', width: 120 },
      // { headerName: 'Has Violation', field: 'hasviolation' , colId: 'hasviolation', width: 100, cellRendererFramework: BooleanCheckComponent },
      { headerName: 'Arrival Time', field: 'arrivaltime' ,  colId: 'arrivaltime', width: 100 },
      // { headerName: 'Waiting Time', field: 'waitingtime' ,  colId: 'waitingtime', width: 100 },
      // { headerName: 'Stop Duration', field: 'stopduration' ,  colId: 'stopduration', width: 100 },
      // { headerName: 'Leave Time', field: 'leavetime' ,  colId: 'leavetime', width: 100 },
      // { headerName: 'Start Time Window', field: 'starttimewindow' ,  colId: 'starttimewindow', width: 100 },
      // { headerName: 'End Time Window', field: 'endtimewindow' ,  colId: 'endtimewindow', width: 100 },
      { headerName: 'TW Violation', field: 'timewindowviolation' ,  colId: 'timewindowviolation', width: 100 }
    ];
  }

  private validateStatusColor(params) {
    if (params.data.hasviolation) {
      return 'trip_cancelled';
    }
  }

  onDragEnd(event) {
    if (event.overNode.id != event.overNode.rowIndex) {
      this.loading.show();
      const obj = {
        'AutoRoutingJobId': this.jobId,
        'ScheduleId': this.scheduleid,
        'AutoRoutingJobResultId': event.node.data.autoroutingjobresultid,
        'newOrder': event.overIndex
      };
      this._autoRoutingService
        .changeOrder(obj)
        .finally(() => {
          this.loading.hiden();
        })
        .subscribe(
          data => {
            this.activeBtn.emit(obj.ScheduleId);
            // this.onReloadLoadDriver.emit(true);
            // this.recalculateProcess(this.scheduleid);
            // this.getTripsForVehicle();
          }, error => {
            this.toastrAlertHelper.warning(error.message);
            this.gridTrips.api.setRowData(this.dataGrid);
          }
        );
    }
  }

  onSelectedZipCode($event) {
    if ($event.colDef.colId === 'remove') {
      this.loading.show();
      const obj = {
        'AutoRoutingJobId': this.jobId,
        'ScheduleId': $event.data.scheduleid,
        'TripId': $event.data.tripid
      };
      this.sweetAlertHelper.createCustomAlert({
        title: 'Are you sure to you want assign this trip?',
        text: 'this is process is irreversible!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          this._autoRoutingService
            .putErase(obj)
            .finally(() => {
              this.loading.hiden();
            })
            .subscribe(
              data => {
                /* this.recalculateProcess(this.scheduleid); */
                this.getTripsForVehicle();
              }, error => {
                this.toastrAlertHelper.error(error.message);
              }
          );
        } else {
          this.loading.hiden();
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/auto-routing-results/components/auto-routing-by-driver/auto-routing-by-driver.component.ts